export default function treeSelectService() {
    return function (list, idfield, textfield) {
        const result = []
        for (const a in list) {
            const tempdata = {}
            $.extend(tempdata, list[a])
            tempdata[idfield] = list[a][idfield]
            tempdata[textfield] = list[a][textfield]
            result.push(tempdata)
        }
        return result
    }
}



// WEBPACK FOOTER //
// ./src/common/services/treeSelectService.js